// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal_modalFullScreen__1ouBh {\n  width: 100%;\n  max-width: 100% !important;\n  margin: 0 !important;\n  display: flex;\n  min-height: 100%;\n  padding-left: 0\n}", "",{"version":3,"sources":["webpack://src/designer/styles/modal.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,0BAA0B;EAC1B,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB;AACF","sourcesContent":[".modalFullScreen {\n  width: 100%;\n  max-width: 100% !important;\n  margin: 0 !important;\n  display: flex;\n  min-height: 100%;\n  padding-left: 0\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalFullScreen": "modal_modalFullScreen__1ouBh"
};
export default ___CSS_LOADER_EXPORT___;
